import { createStore, createHook } from 'react-sweet-state';

const initialState = {
	isAutoOpenDialog: false,
};

export const ShareDialogIsAutoOpenStore = createStore({
	initialState,
	actions: {
		setIsAutoOpenDialog:
			(isAutoOpenDialog) =>
			({ setState }) => {
				setState({ isAutoOpenDialog });
			},
	},
	name: 'shareDialogIsAutoOpenStore',
});

export const useShareDialogIsAutoOpenStore = createHook(ShareDialogIsAutoOpenStore, {
	selector: (state) => state.isAutoOpenDialog,
});
